import { useChatContext } from "../../../../context";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  extractFileName,
  extractUserName,
  capitalizeFirstLetter,
} from "../../utils/util";
 const getColor = (status) => {
    //console.log(status, "statuscolor:::");
    const red = [
      "Flagged for Review",
      "Reviewed,no change",
      "Reviewed,query required",
    ]; // #F8698521;
    const blue = [
      "Reviewed,reclaimed",
      "Reviewed,rebilled",
      "Reviewed,query required",
    ]; // #00395B
    const gray = ["Reviewed,query sent", "Reviewed,recoded"]; // #344054;
    const passed = "passed"; //#E4F5FF
    const failed = "Failed"; //#feecef;
    if (passed === status) {
      return "passed";
    }
    if (failed === status) {
      return "failed";
    }
  
    if (red.includes(status)) return "red";
    if (blue.includes(status)) return "blue";
    if (gray.includes(status)) return "gray";
  };
export default function AuditRowCard  ({
  handleRowClick,
  row,
  isActive,
  flagauditRows,
  unflage,
  selectedEpisodeRows,
  setSelectedEpisodeRows,
  isMouseDown,
  lastCheckedId,
  setIsAllEpisodesSelected,
  isAllEpisodesSelected,
  setLastCheckedId,
  isShiftPressed,
  isFocused,
  selectedColumns,
  unassined_page,
  shouldShowColumn
}) {
  const { webWorkFlow } = useChatContext();
  const { isDateFilterActive } = webWorkFlow;
  const rowRef = useRef(null);
  const checkboxRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isManualCheck, setIsManualCheck] = useState(false);
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const superUserReadOnly = permissions?.super_user_readonly || false;

  const superUser = permissions?.super_user || false;
  const admin = permissions?.admin || false;
  let PrivilegedUser = "";
  if ("Privileged User" in permissions) {
    PrivilegedUser = permissions["Privileged User"];
  } else {
    PrivilegedUser = false;
  }
  const userID = JSON.parse(sessionStorage.getItem("userId"));
  const workflow =
    permissions && Array.isArray(permissions.WorkflowCompanion)
      ? permissions.WorkflowCompanion[0]
      : "";
  const workflowReadOnly =
    permissions && Array.isArray(permissions.WorkflowCompanion)
      ? permissions.WorkflowCompanion[0]
      : "";

  const handleRowSelection = (event, rowData) => {
    if (event.target.checked) {
      const selectedData = [...selectedEpisodeRows, rowData.hcp_line_id];
      setSelectedEpisodeRows(selectedData);
    } else {
      const newAssignedData = selectedEpisodeRows.filter(
        (epsoideId) => epsoideId !== rowData.hcp_line_id
      );
      // setIsAllEpisodesSelected(false)
      // console.log(isAllEpisodesSelected)
      setIsAllEpisodesSelected(false)
      setSelectedEpisodeRows(newAssignedData);
    }
  };

  useEffect(() => {
    if (!isMouseDown) {
      setIsManualCheck(false); 
    }
  }, [isMouseDown]);

  useEffect(() => {
    if (isFocused) {
      rowRef.current?.focus();
    }
  }, [isFocused]);

  useEffect(() => {
    if ((isShiftPressed || isMouseDown) && isHovered && !isManualCheck) {
      const isCurrentlySelected = selectedEpisodeRows.includes(row.hcp_line_id);
      setSelectedEpisodeRows((prev) => {
        if (isCurrentlySelected) {
          return prev.filter((id) => id !== row.hcp_line_id);
        } else {
          return [...prev, row.hcp_line_id];
        }
      });
      setIsAllEpisodesSelected(false)
      setLastCheckedId(row.hcp_line_id);
    }
  }, [isHovered, isShiftPressed, isMouseDown, row.hcp_line_id, isManualCheck]);

  //   const getFormattedDate = (row) => {
  //     const { hcp_line_commented_at, hcp_line_created_at, hcp_line_updated_at } = row;

  //     // Helper function to parse date string (DD-MM-YYYY HH:MM:SS) into a Date object
  //     const parseDate = (dateStr) => {
  //         if (!dateStr) return null;

  //         const [datePart, timePart] = dateStr.split(" ");
  //         const [day, month, year] = datePart.split("-").map(Number);
  //         const [hours, minutes, seconds] = timePart.split(":").map(Number);

  //         return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds)); // Convert to UTC
  //     };

  //     // Convert to Date objects
  //     const createdAt = parseDate(hcp_line_created_at);
  //     const updatedAt = parseDate(hcp_line_updated_at);
  //     const commentedAt = parseDate(hcp_line_commented_at);

  //     if (!createdAt || !updatedAt) {
  //         return "Invalid Date";
  //     }

  //     // Case 1: If `hcp_line_commented_at` is NULL, check if created and updated times are equal
  //     if (!commentedAt) {
  //         if (createdAt.getTime() === updatedAt.getTime()) {
  //             return "No updations";
  //         }
  //         return new Date(Math.max(createdAt.getTime(), updatedAt.getTime())).toLocaleString();
  //     }

  //     // Case 2: If `hcp_line_commented_at` is NOT NULL, show the latest date
  //     return new Date(Math.max(createdAt.getTime(), updatedAt.getTime(), commentedAt.getTime())).toLocaleString();
  // };

  const getFormattedDate = (row) => {
    const { hcp_line_commented_at, hcp_line_created_at, hcp_line_updated_at } =
      row;
    const parseDate = (dateStr) => {
      if (!dateStr) return null;
      const [datePart, timePart] = dateStr.split(" ");
      const [day, month, year] = datePart.split("-").map(Number);
      const [hours, minutes, seconds] = timePart.split(":").map(Number);

      return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
    };
    if (isDateFilterActive) {
      const updatedAt = parseDate(hcp_line_updated_at);
      return updatedAt ? updatedAt.toLocaleString() : "No update";
    }

    const createdAt = parseDate(hcp_line_created_at);
    const updatedAt = parseDate(hcp_line_updated_at);
    const commentedAt = parseDate(hcp_line_commented_at);

    if (!createdAt || !updatedAt) {
      return "No updations";
    }

    const timestamps = [];
    if (createdAt) timestamps.push(createdAt.getTime());
    if (updatedAt) timestamps.push(updatedAt.getTime());
    if (commentedAt) timestamps.push(commentedAt.getTime());

    const latestTimestamp = Math.max(...timestamps);
    const latestDate = new Date(latestTimestamp);

    if (
      latestTimestamp === createdAt.getTime() &&
      (!updatedAt || updatedAt.getTime() === createdAt.getTime()) &&
      !commentedAt
    ) {
      return "No updations";
    }

    return latestDate.toLocaleString();
  };

  const handleRowDoubleClick  =  () =>{
    flagauditRows ? unflage(row):handleRowClick(row)
  }
  // const handleRowClickLocal = (e) => {
  //     console.log("Row clicked:", row.hcp_line_id);
  //   if (!e.target.closest('input[type="checkbox"]') &&!e.target.closest('.view-icon')) {
  //     flagauditRows ? unflage(row) : handleRowClick(row);
  //   }
  // };

  return (
    <>
      <tr
        ref={rowRef}
       tabeIndex={-1}
        className={`auditrow ${isActive && "active"}`}
        // onClick={() => {
        //   flagauditRows ? unflage(row) : handleRowClick(row);
        // }}
        // onClick={handleRowClickLocal}
        onDoubleClick={handleRowDoubleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <td>
          <input
            ref={checkboxRef}
            type="checkbox"
            checked={selectedEpisodeRows?.some(
              (epsoide) => epsoide === row.hcp_line_id
            )}
            onChange={(e) => handleRowSelection(e, row)}
            onMouseDown={(e) => {
              setIsManualCheck(true);
              e.stopPropagation();
            }}
            // onClick={(e) => {
            //   e.stopPropagation();
            //   handleRowSelection(e, row);
            // }}
            disabled={
              !superUser &&
              !admin &&
              (((workflow === "fullAccess" || workflow === "read") &&
                superUserReadOnly) ||
                (workflow === "read" && superUserReadOnly) ||
                (workflow === "fullAccess" && superUser) ||
                (workflow === "read" && superUser) ||
                (PrivilegedUser && workflow === "fullAccess") ||
                (PrivilegedUser && workflow === "read") ||
                (PrivilegedUser && superUserReadOnly) ||
                (PrivilegedUser && superUser)) &&
              row.assigned_to_user_id !== userID
            }
            title={
              !superUser &&
              !admin &&
              (((workflow === "fullAccess" || workflow === "read") &&
                superUserReadOnly) ||
                (workflow === "read" && superUserReadOnly) ||
                (workflow === "fullAccess" && superUser) ||
                (workflow === "read" && superUser) ||
                (PrivilegedUser && workflow === "fullAccess") ||
                (PrivilegedUser && workflow === "read") ||
                (PrivilegedUser && superUserReadOnly) ||
                (PrivilegedUser && superUser)) &&
              row.assigned_to_user_id !== userID &&
              row.assigned_to_user_id !== userID
                ? "You can't assign this episode because you're not the owner"
                : ""
            }
            style={{
              height: "15px",
              width: "15px",
            }}
          />
        </td>
        {/* <td className="view-icon" 
        // onClick={() => {
        //   flagauditRows ? unflage(row) : handleRowClick(row);
        // }}
        
        style={{textAlign:"center",}}>
          
          <MdOpenInNew 
          fontSize={16}
          onClick={handleViewIconClick}
          
          />
        </td> */}
        {shouldShowColumn("priority")&&<td>
          {" "}
          {row.priority_value &&
          row.priority_value.some((val) => val !== null) ? (
            row.priority_value.map((value, index) => (
              <span
                key={index}
                className={`audit-count p${value}`}
                style={{ marginRight: "5px" }}
              >
                P{value}
              </span>
            ))
          ) : (
            <span className="audit-count p5">P5</span>
          )}
        </td>}
        {shouldShowColumn("file_name")&&<td>{row.file_name}</td>}
        {shouldShowColumn("audit_ref_no")&&<td>{row.audit_ref_no}</td>}
        {shouldShowColumn("coded_by")&&<td>{row.coded_by}</td>}
        {shouldShowColumn("uploaded_by_user_name")&&<td>{capitalizeFirstLetter(row.uploaded_by_user_name)}</td>}
        {shouldShowColumn("date")&&<td>{row.date}</td>}
        {shouldShowColumn("assigned_by")&&<td>{unassined_page?capitalizeFirstLetter(row.unassigned_by_user_name):capitalizeFirstLetter(row.assigned_by_user_name)}</td>}
        {shouldShowColumn("assigned_to")&&!unassined_page&&<td>{capitalizeFirstLetter(row.assigned_to_user_name)}</td>}

        {shouldShowColumn("audit_rule_short_description")&& <td>
          {row?.audit_rule_short_description?.map((eachDesc, index) => {
            return (
              <span key={index}>
                {eachDesc}
                {index < row.audit_rule_short_description.length - 1 && ", "}
              </span>
            );
          })}
        </td>}
        {shouldShowColumn("status")&&<td>
          <div className={`audit-status-btn ${getColor(row.status)}`}>
            {row.status}
          </div>
        </td>}
        {shouldShowColumn("episode_identifier")&&<td>{row.episode_identifier}</td>}
        {shouldShowColumn("hcp_line_updated_at")&&<td>{getFormattedDate(row)}</td>}
      </tr>
    </>
  );
};